var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17241_21276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8333 16H23.5L16 8.5L8.5 16H10.1667V21.8333C10.1667 22.2754 10.3423 22.6993 10.6548 23.0118C10.9674 23.3244 11.3913 23.5 11.8333 23.5H16",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.332 21.8333C19.332 22.4963 19.5954 23.1322 20.0643 23.601C20.5331 24.0699 21.169 24.3333 21.832 24.3333C22.4951 24.3333 23.131 24.0699 23.5998 23.601C24.0686 23.1322 24.332 22.4963 24.332 21.8333C24.332 21.1702 24.0686 20.5343 23.5998 20.0655C23.131 19.5966 22.4951 19.3333 21.832 19.3333C21.169 19.3333 20.5331 19.5966 20.0643 20.0655C19.5954 20.5343 19.332 21.1702 19.332 21.8333Z",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 23.5V18.5C13.5 18.058 13.6756 17.6341 13.9882 17.3215C14.3007 17.009 14.7246 16.8334 15.1667 16.8334H16.8333C17.3675 16.8334 17.8433 17.085 18.1483 17.4759",
    stroke: "#1650FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17241_21276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.77e0c78001f84c4d3aeec22a8f8f305f.svg";
export { ForwardRef as ReactComponent };